import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDialog } from 'ogp/providers/dialog-provider';
import { partnerUserAlerts, useAlert } from 'shared/components/alerts';
import { hqRoutes } from 'hq/Routes';
import { QUERY_KEYS } from 'api/query-keys';
import { useDeletePartnerUser } from './use-delete-partner-user';
import { useHqRelativePath } from '../../../../hooks/useHqRelativePath';

const useArchivePartnerUserDialog = (partnerId: string) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const generatePath = useHqRelativePath();
  const { t } = useTranslation(['hq-screen-specific', 'web-common']);
  const { alertSuccess, alertError } = useAlert();
  const archivePartnerUser = useDeletePartnerUser();
  const { openDialog, closeDialog, enableDialog, disableDialog } = useDialog();

  const archivePartnerUserDialog = (partnerUserId: string) => {
    openDialog(
      {
        title: t('partners.dialogs.archive_partner_user.title', { ns: 'hq-screen-specific' }),
      },
      () => {
        disableDialog();
        archivePartnerUser.mutate(partnerUserId, {
          onSuccess: () => {
            closeDialog();
            queryClient.invalidateQueries(QUERY_KEYS.partners());
            alertSuccess(partnerUserAlerts.success.deleted);
            navigate(generatePath(hqRoutes.PartnerUsers, { id: partnerId }));
          },
          onError: (e) => alertError(e),
          onSettled: () => enableDialog(),
        });
      }
    );
  };

  return { open: archivePartnerUserDialog };
};

export { useArchivePartnerUserDialog };
